const CHANNEL_NAME = 'equip-safety-risk-alerts';

export type SafetyRiskAlertBroadcastMessage = {
  type: 'acknowledged';
  safetyRiskAlertId: string;
};

const isBroadcastChannelSupported = (): boolean =>
  typeof BroadcastChannel !== 'undefined';

export const postAcknowledged = (safetyRiskAlertId: string): void => {
  if (!isBroadcastChannelSupported()) {
    return;
  }
  const channel = new BroadcastChannel(CHANNEL_NAME);
  const message: SafetyRiskAlertBroadcastMessage = {
    safetyRiskAlertId,
    type: 'acknowledged',
  };
  channel.postMessage(message);
  channel.close();
};

export const subscribeAcknowledged = (
  handler: (safetyRiskAlertId: string) => void,
): (() => void) => {
  if (!isBroadcastChannelSupported()) {
    return () => {};
  }
  const channel = new BroadcastChannel(CHANNEL_NAME);
  const listener = (event: MessageEvent<SafetyRiskAlertBroadcastMessage>) => {
    if (event.data?.type === 'acknowledged' && event.data.safetyRiskAlertId) {
      handler(event.data.safetyRiskAlertId);
    }
  };
  channel.addEventListener('message', listener);
  return () => {
    channel.removeEventListener('message', listener);
    channel.close();
  };
};
